import React from 'react';
import { SvgIcon } from '@material-ui/core';

const TankIcon = (props) => {
  return(
    <SvgIcon {...props}>
      <path d="M 4.63,2.18
           C 3.57,2.77 3.97,4.52 5.17,4.52
             5.17,4.52 5.61,4.52 5.61,4.52
             5.61,4.52 5.61,7.60 5.61,7.60
             5.61,10.51 5.60,10.68 5.38,10.68
             4.21,10.68 3.59,11.93 4.32,12.81
             4.58,13.12 4.74,13.19 5.13,13.19
             5.13,13.19 5.61,13.19 5.61,13.19
             5.61,13.19 5.61,16.27 5.61,16.27
             5.61,16.27 5.61,19.34 5.61,19.34
             5.61,19.34 5.12,19.42 5.12,19.42
             4.07,19.60 3.66,20.73 4.36,21.53
             4.36,21.53 4.72,21.94 4.72,21.94
             4.72,21.94 11.99,21.94 11.99,21.94
             11.99,21.94 19.25,21.94 19.25,21.94
             19.25,21.94 19.59,21.59 19.59,21.59
             20.37,20.80 19.90,19.59 18.75,19.41
             18.75,19.41 18.26,19.33 18.26,19.33
             18.26,19.33 18.26,16.26 18.26,16.26
             18.26,16.26 18.26,13.19 18.26,13.19
             18.26,13.19 18.71,13.19 18.71,13.19
             20.35,13.19 20.41,10.94 18.77,10.72
             18.77,10.72 18.26,10.65 18.26,10.65
             18.26,10.65 18.26,7.58 18.26,7.58
             18.26,7.58 18.26,4.52 18.26,4.52
             18.26,4.52 18.71,4.52 18.71,4.52
             19.93,4.52 20.43,3.12 19.49,2.32
             19.49,2.32 19.11,2.00 19.11,2.00
             19.11,2.00 12.02,2.00 12.02,2.00
             6.37,2.01 4.87,2.04 4.63,2.18M 13.36,9.04
           C 14.81,11.22 14.97,11.62 14.97,12.94
             14.98,16.49 10.70,17.67 9.25,14.52
             8.54,12.97 9.01,11.39 11.23,7.87
             11.23,7.87 11.85,6.88 11.85,6.88
             11.85,6.88 12.08,7.18 12.08,7.18
             12.21,7.34 12.78,8.18 13.36,9.04" />
    </SvgIcon>
  )
}

export default TankIcon;
